import React, { memo } from "react";
import PharmacyServices from "../../pages/PharmacyServices/PharmacyServices";

function PharmacyServicesPanel() {
  return <PharmacyServices />;
}

export default memo(PharmacyServicesPanel);
